<script>
import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  mounted() {
    this.renderChart(
      {
        labels: ["Nefrite Lúpica - Prova 01", "Nefrite Lúpica - Prova 02", "Nefrite Lúpica - Prova 03", "Nefrite Lúpica - Prova 04"],
        datasets: [
          {
            backgroundColor: ["rgba(0,220,0,.2)", "rgba(220,0,0,.2)", "rgba(0,0,220,.2)", "rgba(0,0,0,.2)"],
            data: [1, 1, 0, 2]
          }
        ]
      },
      { responsive: true, maintainAspectRatio: false }
    );
  }
};
</script>